/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SuccessCardTransactionCardTransactionTransactionRecordListInner
 */
export interface SuccessCardTransactionCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': SuccessCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const SuccessCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type SuccessCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof SuccessCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof SuccessCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];


